import { FLOWS } from '../../utils/constants';

export const FUNNEL_NAME_MAPPER = {
    [FLOWS.CATEGORY]: 'sub_category_page',
    [FLOWS.BUSINESS_CATEGORIES]: 'sub_category_page',
    [FLOWS.SEARCH]: 'search',
    [FLOWS.BUSINESS_SEARCH]: 'search',
    [FLOWS.PROFESSION_CATEGORY]: 'search',
};
